<div class="layout-wrapper" [class.sidebar-active]="sidebarVisible">

  <!-- Sidebar -->
  <aside class="layout-sidebar">
    <div class="sidebar-header">
      <a class="logo" routerLink="/dashboard">
        <img src="assets/images/logo.svg" alt="Maedah Logo" class="logo-image">
      </a>
    </div>

    <div class="sidebar-content">
      <p-panelMenu [model]="menuItems" styleClass="w-full border-none bg-transparent" [multiple]="false"></p-panelMenu>
    </div>
  </aside>

  <div class="layout-overlay" [class.active]="sidebarVisible" (click)="toggleSidebar()"></div>

  <!-- Main Content -->
  <div class="layout-main">
    <!-- Header -->
    <header class="layout-header">
      <div class="header-left">
        <button pButton icon="pi pi-bars" (click)="toggleSidebar()"
                class="p-button-text p-button-plain sidebar-toggle"></button>
        <p-breadcrumb [model]="breadcrumbs" styleClass="border-none bg-transparent p-0 ml-2"></p-breadcrumb>
      </div>

      <div class="header-right">
        <app-clock class="header-clock"></app-clock>
        @if (currentUser) {
          <div class="user-profile" (click)="userMenuPanel.toggle($event)">
            <p-avatar [image]="currentUser.image || 'assets/images/user/person.png'"
                      shape="circle" size="normal" styleClass="cursor-pointer"></p-avatar>
            <div class="user-info">
              <span class="user-name">{{ currentUser.first_name }} {{ currentUser.last_name }}</span>
              <span class="user-role">{{ currentUser.roles && currentUser.roles.length > 0 ? currentUser.roles[0].name : 'Admin' }}</span>
            </div>
            <i class="pi pi-chevron-down text-sm text-gray-400"></i>
          </div>
        }
        <p-tieredMenu #userMenuPanel [model]="userMenu" [popup]="true" appendTo="body"></p-tieredMenu>
      </div>
    </header>

    <!-- Page Content -->
    <main class="layout-content">
      <router-outlet></router-outlet>
      <p-confirmDialog></p-confirmDialog>
    </main>
  </div>
</div>
